import React from 'react';
import Product from './Product';
import './ProductWrapper.css';

const ProductWrapper = ({ product, index, disableClick = false }) => {
  return (
    <div className="product-wrapper">
      <Product key={`product-${index}`} {...product} disableClick={disableClick} />
    </div>
  );
};

export default ProductWrapper;
